(() => {
const dataNode = document.getElementById('native-product-data');
if (!dataNode) return;
const data = JSON.parse(dataNode.textContent);
const gallery = document.querySelector('.native-gallery');
const thumbs = [...document.querySelectorAll('[data-gallery-image]')];
function showImage(id) {
 const slide = [...gallery.children].find(el => el.dataset.imageId === id);
 if (!slide) return;
 gallery.scrollTo({left: slide.offsetLeft - gallery.offsetLeft, behavior: 'smooth'});
 thumbs.forEach(a => { if (a.dataset.galleryImage === id) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
}
thumbs.forEach(a => a.addEventListener('click', event => { event.preventDefault(); showImage(a.dataset.galleryImage); }));
if ('IntersectionObserver' in window) {
 const observer = new IntersectionObserver(entries => { for (const entry of entries) if (entry.isIntersecting && entry.intersectionRatio > 0.6) thumbs.forEach(a => { if (a.dataset.galleryImage === entry.target.dataset.imageId) a.setAttribute('aria-current','true'); else a.removeAttribute('aria-current'); }); }, {root:gallery,threshold:0.6});
 [...gallery.children].forEach(el => observer.observe(el));
}
const select = document.getElementById('shop-variant');
function update(id) {
 const variant = data.variants.find(v => v.id === id);
 if (!variant) return;
 document.querySelector('[data-product-price]').textContent = variant.formattedPrice;
 const message = `Hi Tuffaha, I’m interested in ${data.title}${data.defaultVariant ? '' : ` (${variant.title})`}, listed at ${variant.enquiryPrice} ${data.currency}. Is this configuration available?`;
 const purchase = document.getElementById('product-whatsapp');
 purchase.textContent = variant.available ? 'Buy on WhatsApp' : 'Sold out';
 if (variant.available) {
  purchase.href = 'https://wa.me/96181976685?text=' + encodeURIComponent(message);
  purchase.removeAttribute('aria-disabled');
  purchase.removeAttribute('tabindex');
 } else {
  purchase.removeAttribute('href');
  purchase.setAttribute('aria-disabled', 'true');
  purchase.setAttribute('tabindex', '-1');
 }
 document.querySelector('.shop-contact-caption').textContent = variant.available ? 'Chat with Tuffaha about this product.' : 'This configuration is currently sold out.';
 if (variant.imageId) showImage(variant.imageId);
}
if (select) {
 document.querySelector('.native-variant-apply').hidden = true;
 select.addEventListener('change', () => { update(select.value); const url = new URL(location.href); url.searchParams.set('variant',select.value); history.replaceState(null,'',url); });
 update(select.value);
 const initialUrl = new URL(location.href);
 if (initialUrl.searchParams.has('variant') && initialUrl.searchParams.get('variant') !== select.value) {
  initialUrl.searchParams.set('variant', select.value);
  history.replaceState(null, '', initialUrl);
 }
}
})();
